import React, { useState, useEffect } from 'react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

const ClockWidget: React.FC<WidgetProps> = () => {
  const { theme } = useSecondScreenData();
  const isDark = theme === 'dark';
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  const timeStr = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="flex flex-col items-center justify-center h-full gap-1 px-3">
      <div
        className={`font-mono font-bold tracking-wider ${isDark ? 'text-white' : 'text-slate-900'}`}
        style={{
          fontSize: 'clamp(3rem, 8vw, 6rem)',
          ...(isDark ? { textShadow: '0 0 20px rgba(0, 199, 196, 0.3)' } : {}),
        }}
      >
        {timeStr}
      </div>
    </div>
  );
};

export default ClockWidget;
